import { render } from "./Age.vue?vue&type=template&id=36d1b64d"
import script from "./Age.vue?vue&type=script&lang=js"
export * from "./Age.vue?vue&type=script&lang=js"

import "./Age.vue?vue&type=style&index=0&id=36d1b64d&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__